<template>
    <div class="quarter-picker" :class="{ 'quarter-picker-disabled': disabled, 'quarter-picker-active': isShowPopover }"
    :style="{'background': backgroundColor? backgroundColor: isShowPopover? 'none': '#F5F5F7','border': isHasBorder && !isShowPopover? '1px solid #DCDFE6':''}">
        <div class="quarter-picker-date-button">
            <i class="iconfont icon-date-select-icon quarter-picker-time-icon" />
            <el-popover placement="bottom" width="225" trigger="click" ref="datePopover" :disabled="disabled"
                @show="initPopover" @hide="hidePopover">
                <div class="quarter-picker-date-button-item quarter-picker-date-button-item-long" slot="reference">
                    <span v-if="form.date" class="button-item-span">
                        {{ dateQuarterStr }}
                    </span>
                    <span v-else class="button-item-span dust-color">选择季度</span>
                    <div class="bottom-line" />
                </div>
                <quarterPanel ref="quarterPanelRef" v-model="form.date" :dice="dice" :min="min" :max="max" :featureDisabled="featureDisabled"
                    :todayDisabled="todayDisabled" @input="emitDateChange()" />
            </el-popover>
            <i v-show="form.date && clearable" class="el-icon-circle-close quarter-picker-clear-icon"
                @click.stop="clearCurrentDate" />
        </div>
    </div>
</template>

<script>
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import quarterOfYear from 'dayjs/plugin/quarterOfYear'
import quarterPanel from './quarterPanel.vue'

dayjs.extend(customParseFormat)
dayjs.extend(quarterOfYear)

/**
 * date 日期
 */
export default {
    name: 'QuarterPicker',
    components: {
        quarterPanel,
    },
    props: {
        date: {
            type: String,
            default: ''
        },
        min: {
            type: String,
            default: ''
        },
        max: {
            type: String,
            default: ''
        },
        featureDisabled:  {
            type: Boolean,
            default: false
        },
        todayDisabled:  {
            type: Boolean,
            default: false
        },
        disabled:  {
            type: Boolean,
            default: false
        },
        clearable:  {
            type: Boolean,
            default: false
        },
        placeholder: {
            type: String,
            default: '选择季' 
        },
        selectedType: {
            type: String,
            default: '0'
        },
        backgroundColor: {
            type: String,
            default: ''
        },
        isHasBorder: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            form: {
                date: '',
            },
            dice: 0,
            isShowPopover: false,
        }
    },
    mounted() {
        this.syncData()
    },
    computed: {
        dateQuarterStr() {
            if (!this.form.date) return this.placeholder;

            const dj = dayjs(this.form.date).startOf('quarter')
            if(this.selectedType == '1') {
                return `${dj.year()}年第${dj.quarter()}季度`
            }
            return `${dj.year()}-Q${dj.quarter()}`
        },
    },
    methods: {
        initPopover() {
            this.dice++
            this.isShowPopover = true;
        },
        hidePopover() {
            this.isShowPopover = false;
        },
        syncData() {
            this.form.date = this.date
        },
        clearCurrentDate() {
            if (this.disabled) return
            this.form.date = ''
            // this.$refs.quarterPanelRef.clearValue();
            this.$emit('change', '')
            this.closePopovers()

            // this.emitDateChange()
        },
        emitDateChange() {
            this.$emit('change', this.form.date)

            this.closePopovers()
        },
        closePopovers() {
            this.$refs.datePopover.doClose()
        },
    },
    watch: {
        date() {
            if (this.form.date !== this.date) {
                this.syncData()
            }
        },
    },
}
</script>

<style scoped lang="scss">
$--gw-primary-color: #f6674f;

.quarter-picker {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 145px;
    height: 32px;
    padding: 0 8px;
    border-radius: 2px;


    .quarter-picker-date-button {
        display: flex;
        position: relative;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        user-select: none;
        height: 28px;
        font-size: 12px;
        border-radius: 2px;
        cursor: pointer;

        .quarter-picker-time-icon {
            position: absolute;
            left: 12px;
        }

        .quarter-picker-date-button-item {
            position: relative;
            height: 28px;
            line-height: 28px;
            width: 140px;
            cursor: pointer;

            .bottom-line {
                position: absolute;
                bottom: 0;
                left: 0;
                right: 0;
                height: 2px;
                border-radius: 1px;
                background: transparent;
            }

            // &:hover {
            //       .bottom-line {
            //         background: $--gw-primary-color;
            //       }
            // }
        }

        .quarter-picker-date-button-item-long {
            // width: 200px;

            .button-item-span {
                display: inline-block;
                // width: 90px;
                // color: #999999;
                // text-align: center;
            }

            .button-item-span-active {
                // color: $--gw-primary-color;
            }
        }

        .quarter-picker-clear-icon {
            position: absolute;
            right: 12px;
            font-size: 12;
            color: #d9cdd5;
            display: none;

            // &:hover {
            //     color: $--gw-primary-color;
            // }
        }

        &:hover .quarter-picker-clear-icon {
            display: block;
            //   .bottom-line {
            //     background: $--gw-primary-color;
            //   }
        }
    }
}

.quarter-picker-active {
    border: 1px solid #2768FF
}

.quarter-picker-disabled {
    .quarter-picker-date-button {
        color: #c0c4cc;
        background-color: #f2f6fc;

        .quarter-picker-date-button-item {
            cursor: not-allowed;
        }
    }

    .quarter-picker-date-button-item {
        // &:hover {
        //     .bottom-line {
        //       background: transparent !important;
        //     }
        // }
    }

    .quarter-picker-clear-icon {
        cursor: not-allowed !important;

        // &:hover {
        //     color: #c0c4cc !important;
        // }
    }
}

.dust-color {
    color: #999999;
}
</style>